import Tooltip from 'bootstrap/js/dist/tooltip';

function equalizeHeights(selector) {
    let items = document.querySelectorAll(selector);
    let max = 0;
    items.forEach(el => {
      el.style.height = "auto"; // reset
      if (el.offsetHeight > max) {
        max = el.offsetHeight;
      }
    });
    items.forEach(el => el.style.height = max + "px");
}

// Run on load + resize
window.addEventListener("load", () => equalizeHeights(".location-item"));
window.addEventListener("resize", () => equalizeHeights(".location-item"));

async function initAutocomplete() {
    const { PlaceAutocompleteElement } = await google.maps.importLibrary("places");

    document.querySelectorAll('.locationForm, .locationsForm').forEach(form => {
        // const addressHidden = document.getElementById('address-hidden');

        const addressHidden = form.querySelector('.address-hidden');

        form.querySelectorAll('.postcode-input').forEach(originalInput => {
            // Create the new autocomplete element
            const autocompleteElement = new PlaceAutocompleteElement({
              includedRegionCodes: ['uk'],
              includedPrimaryTypes: ['locality'],
            });

            // Copy placeholder and name attributes if needed
            // autocompleteElement.placeholder = originalInput.placeholder;
            // autocompleteElement.name = originalInput.name;

            // Replace original input
            originalInput.replaceWith(autocompleteElement);

            // Listen for place change
            autocompleteElement.addEventListener('gmp-select', async ({ placePrediction }) => {
                const place = placePrediction.toPlace();
                await place.fetchFields({ fields: ['displayName', 'formattedAddress', 'location'] });
                        
                if (place && place.formattedAddress) {
                    addressHidden.value = place.formattedAddress;
                }
            });
        });
    });
}

window.addEventListener('load', () => {
    // Nothing to autocomplete if the page has no location-search form (Maps JS is also not loaded in that case).
    if (!document.querySelector('.locationForm, .locationsForm')) {
        return;
    }

    if (typeof google !== 'undefined' && google.maps) {
        initAutocomplete();
    } else {
        console.error("Google Maps JavaScript API not loaded.");
    }
});

// Optimized Location Form Handler - Pure Vanilla JavaScript
// No dependencies required - works with existing jQuery/WordPress setup

// Cache for storing results
const LocationCache = {
  geocoding: new Map(),
  offices: null,
  officesTimestamp: 0,
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
}

// Configuration - Update these values for your setup
const CONFIG = {
  apiKey: "AIzaSyBZ9NoaJATHwPRUVx-nTd_lI3As3Rk1EIo", // Replace with your actual API key
  officeEndpoint: bridgewaterAjax.ajaxUrl,
}

// Optimized distance calculation using Haversine formula
function calculateDistance(lat1, lng1, lat2, lng2) {
  const R = 6371 // Earth's radius in kilometers
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLng = ((lng2 - lng1) * Math.PI) / 180
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}

// Updated findNearestOffice function with your specific logic
function findNearestOffice(lat, lng, offices, postcode) {
  // Clear any existing nearest office data
  localStorage.removeItem('nearestOffice');
  
  if (!offices || offices.length === 0) return null;

  var userLocation = new window.google.maps.LatLng(lat, lng);
  var minDistance = Infinity;
  var nearestOffice = null;

  offices.forEach(function(office) {
    var officeLocation = new window.google.maps.LatLng(office.lat, office.lng);
    var distance = window.google.maps.geometry.spherical.computeDistanceBetween(userLocation, officeLocation);
    
    if (distance < minDistance) {
      minDistance = distance;
      nearestOffice = office;
    }
  });

  if (nearestOffice) {
    var resultData = {
      officeName: nearestOffice.name,
      distanceNumber: (minDistance / 1000 * 0.6214).toFixed(2),
      distance: (minDistance / 1000 * 0.6214).toFixed(2) + " mi",
      lat: nearestOffice.lat,
      lng: nearestOffice.lng,
      phone: nearestOffice.phone,
      email: nearestOffice.email,
      website: nearestOffice.website,
      address: nearestOffice.address,
      description: nearestOffice.description,
      displayImage: nearestOffice.displayImage,
      servicesMenu: nearestOffice.servicesMenu,
      heroButtonGroup: nearestOffice.heroButtonGroup
    };

    const searchDate = Date.now();
    
    if (resultData.distanceNumber < 50) {
      // Store data and redirect to office website
      localStorage.setItem('lastSearch', searchDate);
      localStorage.setItem('nearestOffice', JSON.stringify(resultData));
      window.location.href = resultData.website;
    } else {
      // Redirect to locations page for distant offices
      window.location.href = '/locations/?address=' + postcode;
    }
    
    return resultData;
  } else {
    return null;
  }
}

// Updated findNearestOffice function with your specific logic
function findNearestOfficeLocations(lat, lng, offices) {
  if (!offices || offices.length === 0) return null;

  var userLocation = new window.google.maps.LatLng(lat, lng);

  let distances = [];

  offices.forEach(function(office) {
    var officeLocation = new window.google.maps.LatLng(office.lat, office.lng);
    var distance = window.google.maps.geometry.spherical.computeDistanceBetween(userLocation, officeLocation);

    distances.push({
      id: office.id,
      name: office.name,
      distanceNumber: (distance / 1000 * 0.6214).toFixed(2),
      distance: (distance / 1000 * 0.6214).toFixed(2) + " miles away",
    });
  });

  distances.sort((a,b) => a.distanceNumber - b.distanceNumber);

  (function($) {
      $.ajax({
          url: ajaxurl.url,
          type: 'POST',
          data: {
              action: 'multisite_title_search',
              distances: distances,
              nonce: bridgewaterAjax.nonce,
          },
          success: function(response) {
              $('#location-items').html(response);
          }
      });
  })( jQuery );
}

// Cached geocoding function
async function geocodePostcode(postcode) {
  const cacheKey = postcode.toLowerCase().trim()

  // Check cache first
  if (LocationCache.geocoding.has(cacheKey)) {
    console.log("Using cached geocoding result for:", postcode)
    return LocationCache.geocoding.get(cacheKey)
  }

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(postcode)}&key=${CONFIG.apiKey}`

  try {
    const response = await fetch(url)
    const data = await response.json()

    if (data.status === "OK" && data.results.length > 0) {
      const location = data.results[0].geometry.location
      const result = { lat: location.lat, lng: location.lng }

      // Cache the result
      LocationCache.geocoding.set(cacheKey, result)
      console.log("Cached geocoding result for:", postcode)
      return result
    } else {
      throw new Error("Invalid postcode/location")
    }
  } catch (error) {
    console.error("Geocoding error:", error)
    throw new Error("Geocoding failed")
  }
}

// Cached office fetching function
async function fetchOffices() {
  const now = Date.now()

  // Return cached offices if still valid
  if (LocationCache.offices && now - LocationCache.officesTimestamp < LocationCache.CACHE_DURATION) {
    console.log("Using cached office data")
    return LocationCache.offices
  }

  try {
    const response = await fetch(`${CONFIG.officeEndpoint}?action=get_office_locations&nonce=${encodeURIComponent(bridgewaterAjax.nonce)}`)
    const offices = await response.json()

    // Update cache
    LocationCache.offices = offices
    LocationCache.officesTimestamp = now
    console.log("Cached office data, count:", offices.length)

    return offices
  } catch (error) {
    console.error("Office fetching error:", error)
    throw new Error("Failed to load office locations")
  }
}

// Update the main form handler success section
async function handleLocationFormSubmit(event) {
  event.preventDefault();

  const form = event.target;
  const postcode = form.querySelector(".address-hidden")?.value?.trim();

  if (!postcode) {
    // form.querySelector(".result").innerHTML = "Please enter a postcode.";
    return;
  }

  // Show loading state
  // form.querySelector(".result").innerHTML = "Finding nearest office...";

  // Disable submit button during processing
  const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
  const originalButtonText = submitButton?.textContent || submitButton?.value;

  if (submitButton) {
    submitButton.disabled = true;
    if (submitButton.textContent !== undefined) {
      submitButton.textContent = "Processing...";
    } else {
      submitButton.value = "Processing...";
    }
  }

  try {
    console.log("Processing postcode:", postcode);

    // Run geocoding and office fetching in parallel for maximum performance
    const startTime = performance.now();
    const [location, offices] = await Promise.all([geocodePostcode(postcode), fetchOffices()]);

    const parallelTime = performance.now() - startTime;
    console.log(`Parallel API calls completed in ${parallelTime.toFixed(2)}ms`);

    // Find nearest office with your specific logic (includes redirect)
    const findStartTime = performance.now();
    const nearestOffice = findNearestOffice(location.lat, location.lng, offices, postcode);
    const findTime = performance.now() - findStartTime;
    console.log(`Nearest office found in ${findTime.toFixed(2)}ms`);

    // Note: If nearestOffice is found, the function will redirect automatically
    // This code only runs if no office is found or redirect fails
    if (!nearestOffice) {
      // form.querySelector(".result").innerHTML = "No offices found.";
    }
  } catch (error) {
    console.error("Form submission error:", error);
    // form.querySelector(".result").innerHTML = error.message || "An error occurred.";
  } finally {
    // Re-enable submit button (in case redirect doesn't happen)
    if (submitButton) {
      submitButton.disabled = false;
      if (submitButton.textContent !== undefined) {
        submitButton.textContent = originalButtonText;
      } else {
        submitButton.value = originalButtonText;
      }
    }
  }
}

// Update the main form handler success section
async function handleLocationsFormSubmit(event) {
  event.preventDefault();

  const form = event.target;
  const postcode = form.querySelector(".address-hidden")?.value?.trim();

  if (!postcode) {
    // form.querySelector(".result").innerHTML = "Please enter a postcode.";
    return;
  }

  // Show loading state
  // form.querySelector(".result").innerHTML = "Finding nearest office...";

  // Disable submit button during processing
  const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
  const originalButtonText = submitButton?.textContent || submitButton?.value;

  if (submitButton) {
    submitButton.disabled = true;
    if (submitButton.textContent !== undefined) {
      submitButton.textContent = "Processing...";
    } else {
      submitButton.value = "Processing...";
    }
  }

  try {
    console.log("Processing postcode:", postcode);

    // Run geocoding and office fetching in parallel for maximum performance
    const startTime = performance.now();
    const [location, offices] = await Promise.all([geocodePostcode(postcode), fetchOffices()]);

    const parallelTime = performance.now() - startTime;
    console.log(`Parallel API calls completed in ${parallelTime.toFixed(2)}ms`);

    // Find nearest office with your specific logic (includes redirect)
    const findStartTime = performance.now();
    const nearestOffice = findNearestOfficeLocations(location.lat, location.lng, offices);
    const findTime = performance.now() - findStartTime;
    console.log(`Nearest office found in ${findTime.toFixed(2)}ms`);

    // Note: If nearestOffice is found, the function will redirect automatically
    // This code only runs if no office is found or redirect fails
    if (!nearestOffice) {
      // form.querySelector(".result").innerHTML = "No offices found.";
    }
  } catch (error) {
    console.error("Form submission error:", error);
    // form.querySelector(".result").innerHTML = error.message || "An error occurred.";
  } finally {
    // Re-enable submit button (in case redirect doesn't happen)
    if (submitButton) {
      submitButton.disabled = false;
      if (submitButton.textContent !== undefined) {
        submitButton.textContent = originalButtonText;
      } else {
        submitButton.value = originalButtonText;
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const postcode = params.get("address");

  if (postcode) {
    const locationsForm = document.querySelector("#locationsForm");
    locationsForm.addEventListener("submit", handleLocationsFormSubmit);
    
    if (locationsForm) {
      const hiddenInput = locationsForm.querySelector(".address-hidden");
      if (hiddenInput) {
        hiddenInput.value = postcode.trim();
      }

      setTimeout(async () => {
        locationsForm.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      }, 1000);
    }
  }
});

// Cache management utilities
const CacheManager = {
  // Clear all caches
  clearAll() {
    LocationCache.geocoding.clear()
    LocationCache.offices = null
    LocationCache.officesTimestamp = 0
    console.log("All caches cleared")
  },

  // Get cache statistics
  getStats() {
    const now = Date.now()
    return {
      geocodingCacheSize: LocationCache.geocoding.size,
      officesCached: !!LocationCache.offices,
      officesAge: LocationCache.officesTimestamp ? Math.round((now - LocationCache.officesTimestamp) / 1000) : 0,
      officesExpired: LocationCache.officesTimestamp
        ? now - LocationCache.officesTimestamp > LocationCache.CACHE_DURATION
        : true,
    }
  },

  // Log cache statistics
  logStats() {
    const stats = this.getStats()
    console.log("Cache Statistics:", stats)
  },
}

// Update the DOMContentLoaded event to load Google Maps API
document.addEventListener("DOMContentLoaded", async () => {
  console.log("Location optimizer initialized");

  // Preload offices in background after a short delay
  setTimeout(async () => {
    try {
      await fetchOffices();
      console.log("Offices preloaded successfully");
    } catch (error) {
      console.log("Office preloading failed (non-critical):", error.message);
    }
  }, 1000);

  // Make cache manager available globally for debugging
  window.CacheManager = CacheManager;
  CacheManager.logStats();
});

// Replace your original jQuery event handler with this optimized version
document.addEventListener("DOMContentLoaded", () => {
  const forms = document.querySelectorAll(".locationForm")
  forms.forEach((form) => {
    form.addEventListener("submit", handleLocationFormSubmit)
  })

  const locationsForms = document.querySelectorAll(".locationsForm")
  locationsForms.forEach((locationsForm) => {
    locationsForm.addEventListener("submit", handleLocationsFormSubmit)
  })
})

function isSameSite(url) {
    try {
        const givenUrl = new URL(url, window.location.origin); // Handles relative URLs
        return givenUrl.origin === window.location.origin;
    } catch (e) {
        return false; // Invalid URL
    }
}

function updateExternalLinks() {

    document.querySelectorAll('a[target="_blank"]').forEach(anchor => {
        if (!anchor.hasAttribute('data-bs-toggle')) {
            if(anchor.title) {
                anchor.setAttribute('aria-label', anchor.title);    
            }
            anchor.setAttribute('data-bs-toggle', 'tooltip');
            anchor.setAttribute('data-bs-placement', 'bottom');
            anchor.setAttribute('data-bs-title', 'Opens in a new tab');
        }

        if (anchor.classList.contains('btn') && !anchor.classList.contains('btn-external-arrow-right') && !anchor.classList.contains('btn-external-arrow-left')) {
            anchor.classList.add('btn-external-arrow-right');
            anchor.insertAdjacentHTML('beforeend', '<i class="fa-solid fa-arrow-up-right-from-square"></i>');
        }

        if(!isSameSite(anchor.getAttribute("href"))) {
            if (!anchor.getAttribute("rel")?.includes("noopener") || !anchor.getAttribute("rel")?.includes("noreferrer")) {
                anchor.setAttribute("rel", "noopener noreferrer");
            }
        }
    });
}

function initialiseTooltips() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    var nearestOffice = localStorage.getItem("nearestOffice");
    
    if (nearestOffice !== null) {
        document.querySelectorAll('.locationFormHero').forEach(el => el.classList.add('d-none'));
        const hasLocation = document.getElementById('hasLocation');
        if (hasLocation) hasLocation.classList.remove('d-none');
        const locationButtons = document.getElementById('locationButtons');
        if (locationButtons) locationButtons.classList.remove('d-none');
        const locationDetailsHome = document.getElementById('locationDetailsHome');
        if (locationDetailsHome) locationDetailsHome.classList.remove('d-none');
    } else {
        document.querySelectorAll('.locationFormHero').forEach(el => el.classList.remove('d-none'));
        const locationButtons = document.getElementById('locationButtons');
        if (locationButtons) locationButtons.classList.add('d-none');
        const hasLocation = document.getElementById('hasLocation');
        if (hasLocation) hasLocation.classList.add('d-none');
    }

    function stripHTML(input) {
        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = input;
        return tempDiv.textContent || tempDiv.innerText || "";
    }

    // Force new search after 1 day to allow localstorage data to be updated
    var searchTime = Number(localStorage.getItem('lastSearch'));
    var expiryTime = searchTime + 86400000;
    var currentTime = Date.now();
    
    if (currentTime > expiryTime) {
        document.querySelectorAll('.offcanvasContactHome').forEach(el => el.classList.add('d-none'));
        const hasLocation = document.getElementById('hasLocation');
        if (hasLocation) hasLocation.classList.add('d-none');
        document.querySelectorAll('.locationFormHero').forEach(el => el.classList.remove('d-none'));
        const locationDetailsHome = document.getElementById('locationDetailsHome');
        if (locationDetailsHome) locationDetailsHome.classList.add('d-none');
        const locationButtons = document.getElementById('locationButtons');
        if (locationButtons) locationButtons.classList.add('d-none');
        localStorage.removeItem('nearestOffice');
    } else {
        // Load previous result from local storage
        var savedResult = localStorage.getItem('nearestOffice');
        if (savedResult) {
            var officeData = JSON.parse(savedResult);

            document.querySelectorAll(".get-title").forEach(el => {
                el.innerHTML = officeData.officeName;
            });

            if (officeData.phone) {
                document.querySelectorAll(".get-phone").forEach(el => {
                    el.innerHTML = "<a class='nav-link' href='tel:" + officeData.phone.replace(/\s/g, "") + "'><span class='icon'><svg aria-label='Phone Icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path class='fa-secondary' opacity='.4' d='M48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5z'/><path class='fa-primary' d='M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z'/></svg></span><span class='label'>Call Us</span></a>";
                });
            } else {
                document.querySelectorAll(".get-phone").forEach(el => {
                    el.innerHTML = '';
                });
            }

            if (officeData.email) {
                document.querySelectorAll(".get-email").forEach(el => {
                    el.innerHTML = "<a class='nav-link' href='mailto:" + officeData.email + "'><span class='icon'><svg aria-label='Email Icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path class='fa-secondary' opacity='.4' d='M48 128l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112c-8.8 0-16 7.2-16 16zm0 84.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2z'/><path class='fa-primary' d='M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z'/></svg></span><span class='label'>Email Us</span></a>";
                });
            } else {
                document.querySelectorAll(".get-email").forEach(el => {
                    el.innerHTML = '';
                });
            }

            if (officeData.address) {
                document.querySelectorAll(".get-address").forEach(el => {
                    el.innerHTML = "<a class='nav-link' target='_blank' href='https://www.google.com/maps?q=" + stripHTML(officeData.address) + "' target='_blank'><span class='icon'><svg aria-label='Address Icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path class='fa-secondary' opacity='.4' d='M48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192c0-79.5-64.5-144-144-144S48 112.5 48 192z'/><path class='fa-primary' d='M320.7 249.2c-10.5 24.8-25.4 52.2-42.5 79.9C249.8 375.3 216.8 420 192 451.7c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9C52.5 223.6 48 204.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2zm-105 250C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z'/></svg></span><span class='label'>Visit Us</span></a>";
                });
            } else {
                document.querySelectorAll(".get-address").forEach(el => {
                    el.innerHTML = '';
                });
            }

            if (officeData.website) {
                document.querySelectorAll(".get-website").forEach(el => {
                    el.innerHTML = "<a class='nav-link' href='" + stripHTML(officeData.website) + "' target='_blank'><span class='icon'><svg aria-label='Website Icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path class='fa-secondary' opacity='.4' d='M48 256c0 5.5 .2 10.9 .6 16.3c26.5-7.8 52.9-15.6 79.4-23.4c.2-14 .9-27.7 2.2-41l-76.7 0c-3.6 15.4-5.6 31.5-5.6 48zm23.4-96l65.9 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4zm105 74.7c19.5-5.7 38.9-11.4 58.3-17.2c36.4-10.7 70.3 23.1 59.6 59.6L286.5 304l47 0c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48l-155 0c-.9 8.7-1.6 17.6-2 26.7zm9.9-74.7l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm54.8 298.3c6.5 4.5 11.8 5.7 14.8 5.7c7.4 0 27-7.2 47.6-48.4c8.8-17.7 16.4-39.2 22-63.6l-53.2 0c-10.4 35.4-20.8 70.8-31.3 106.3zm101-391.6c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0c-21.4-41.1-56.1-74.1-98.4-93.4zm0 378.8c42.3-19.3 77-52.3 98.4-93.4l-65.9 0c-7.3 35.9-18.5 67.7-32.6 93.4zM381.8 208c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48l76.7 0c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48l-76.7 0z'/><path class='fa-primary' d='M303.6 415.6C283 456.8 263.4 464 256 464c-3.1 0-8.3-1.3-14.8-5.7l-15.3 52c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.2 .6 20.2 1.8 30.1l46.9-13.8c-.4-5.4-.6-10.8-.6-16.3c0-16.5 1.9-32.6 5.6-48l76.7 0c-1.3 13.3-2 27-2.2 41l48.4-14.2c.4-9.1 1.1-18 2-26.7l155 0c1.6 15.3 2.5 31.4 2.5 48s-.9 32.7-2.5 48l-47 0-14.1 48 53.2 0c-5.6 24.4-13.2 45.9-22 63.6zM208.4 96.4C229 55.2 248.6 48 256 48s27 7.2 47.6 48.4c8.8 17.7 16.4 39.2 22 63.6l-139.2 0c5.6-24.4 13.2-45.9 22-63.6zM384 256c0-16.4-.8-32.5-2.2-48l76.7 0c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48l-76.7 0c1.5-15.5 2.2-31.6 2.2-48zm-9.3-96c-7.3-35.9-18.5-67.7-32.6-93.4c42.3 19.3 77 52.3 98.4 93.4l-65.9 0zM71.4 160c21.4-41.1 56.1-74.1 98.4-93.4c-14.1 25.6-25.3 57.5-32.6 93.4l-65.9 0zM374.7 352l65.9 0c-21.4 41.1-56.1 74.1-98.4 93.4c14.1-25.6 25.3-57.5 32.6-93.4zM39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3 .7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9L39 308.5z'/></svg></span><span class='label'>Website</span></a>";
                });
            } else {
                document.querySelectorAll(".get-website").forEach(el => {
                    el.innerHTML = '';
                });
            }

            document.querySelectorAll(".get-description").forEach(el => {
                el.innerHTML = officeData.description;
            });

            if (officeData.servicesMenu) {
                document.querySelectorAll(".get-services-menu").forEach(el => {
                    el.innerHTML = "<h4>" + officeData.officeName + " care services</h4>" + officeData.servicesMenu;
                });
            } else {
                document.querySelectorAll(".get-services-menu").forEach(el => {
                    el.innerHTML = '';
                });
            }

            if (officeData.displayImage) {
                document.querySelectorAll(".get-display-image").forEach(el => {
                    el.innerHTML = "<img width='" + officeData.displayImage.sizes["medium_large-width"] + "' height='" + officeData.displayImage.sizes["medium_large-height"] + "' src='" + officeData.displayImage.sizes.medium_large + "' />";
                });
            } else {
                document.querySelectorAll(".get-display-image").forEach(el => {
                    el.innerHTML = '';
                });
            }

            if (officeData.heroButtonGroup && officeData.heroButtonGroup.buttons != false) {
                let container = document.getElementById("locationButtons");
                if (container) {
                    officeData.heroButtonGroup.buttons.forEach(button => {
                        let btnElement = document.createElement("a");
                        if (button.style == 'hollow') {
                            button.colour = 'btn-outline-' + button.colour;
                            button.style = 'btn';
                        } else if (button.style == 'fill') {
                            button.colour = 'btn-' + button.colour;
                            button.style = 'btn';
                        } else if (button.style == 'clear') {
                            button.colour = 'btn-' + button.colour;
                            button.style = 'btn-link';
                        }
                        if (button.arrow == 'btn-arrow-right') {
                            btnElement.innerHTML = `${button.link.title}` + '<i class="fa-solid fa-arrow-right"></i>';
                        } else if (button.arrow == 'btn-arrow-left') {
                            btnElement.innerHTML = '<i class="fa-solid fa-arrow-left"></i>' + `${button.link.title}`;
                        } else {
                            btnElement.innerHTML = `${button.link.title}`;
                        }
                        btnElement.href = button.link.url;
                        btnElement.className = `${button.style} ${button.colour} ${button.arrow}`;
                        btnElement.target = button.link.target;
                        container.prepend(btnElement);
                    });
                }
            }

            document.querySelectorAll('.offcanvasContactHome').forEach(el => el.classList.remove('d-none'));
            const locationDetailsHome = document.getElementById('locationDetailsHome');
            if (locationDetailsHome) locationDetailsHome.classList.remove('d-none');
            
            // These functions need to be defined elsewhere in your code
            if (typeof updateExternalLinks === 'function') {
                updateExternalLinks();
            }
            if (typeof initialiseTooltips === 'function') {
                initialiseTooltips();
            }
        }
    }

    // Event listener for search again button
    const searchAgainBtn = document.getElementById('searchAgain');
    if (searchAgainBtn) {
        searchAgainBtn.addEventListener('click', function() {
            document.querySelectorAll('.offcanvasContactHome').forEach(el => el.classList.add('d-none'));
            const hasLocation = document.getElementById('hasLocation');
            if (hasLocation) hasLocation.classList.add('d-none');
            document.querySelectorAll('.locationFormHero').forEach(el => el.classList.remove('d-none'));
            const locationDetailsHome = document.getElementById('locationDetailsHome');
            if (locationDetailsHome) locationDetailsHome.classList.add('d-none');
            const locationButtons = document.getElementById('locationButtons');
            if (locationButtons) locationButtons.classList.add('d-none');
            
            let container = document.getElementById("locationButtons");
            if (container) {
                let links = container.querySelectorAll("a");
                links.forEach(link => link.remove());
            }
            localStorage.removeItem('nearestOffice');
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    updateExternalLinks();
    initialiseTooltips();
});

document.addEventListener('DOMContentLoaded', function () {

    function handleToggle() {
      const screenWidth = window.innerWidth;
      const toggles = document.querySelectorAll('[data-toggle="dropdown"]');

      toggles.forEach(toggle => {
        if (screenWidth >= 1360) {
          toggle.removeAttribute('data-bs-toggle');
        } else {
          toggle.setAttribute('data-bs-toggle', 'dropdown');
        }
      });
    }

    handleToggle();

    window.addEventListener('resize', handleToggle);
}); 


document.addEventListener( 'DOMContentLoaded', function () {

    const accreditation_slider = document.querySelectorAll('.accreditation_slider');
    accreditation_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'loop',
            rewind: true,
            pagination: false,
            perPage: 7,
            perMove: 1,
            arrows: false,
            gap: '2rem',
            autoplay: true,
            interval: 2000,
            breakpoints: {
                300: {
                    perPage: 1,
                    gap: '1rem',
                },
                768: {
                    perPage: 3,
                    gap: '1.5rem',
                },
                1200: {
                    perPage: 4,
                    gap: '1.5rem',
                },
                1400: {
                    perPage: 5,
                    gap: '1.5rem',
                },
            }
        }).mount();
    });

    const stats_slider = document.querySelectorAll('.stats_slider');
    stats_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'slide',
            pagination: false,
            perPage: 3,
            perMove: 1,
            arrows: false,
            autoplay: true,
            interval: 3000,
            breakpoints: {
                300: {
                    perPage: 1,
                    type: 'loop',
                },
                768: {
                    perPage: 2,
                    type: 'loop',
                },
                1200: {
                    perPage: 3,
                    type: 'slide',
                },
            }
        }).mount();
    });

    const content_slider = document.querySelectorAll('.content_slider');
    content_slider.forEach((slider, index) => { 

        var slides = slider.querySelectorAll('.splide__slide');
        var slidesCount = slides.length;

        var screen_768_perPage = 1;
        var screen_1200_perPage = 2;
        var screen_1400_perPage = 3;

        new Splide(slider, {
            type: 'slide',
            rewind: true,
            pagination: false,
            perPage: screen_1400_perPage,
            perMove: 1,
            drag: 'free',
            gap: '2.5rem',
            arrows: slidesCount > screen_1400_perPage,
            breakpoints: {
                768: {
                    perPage: screen_768_perPage,
                    gap: '1.5rem',
                    arrows: slidesCount > screen_768_perPage,
                },
                1200: {
                    perPage: screen_1200_perPage,
                    gap: '1.5rem',
                    arrows: slidesCount > screen_1200_perPage,
                },
                1400: {
                    perPage: screen_1400_perPage,
                    gap: '1.5rem',
                    arrows: slidesCount > screen_1400_perPage,
                },
            }
        }).mount();
    });

    const posts_slider = document.querySelectorAll('.posts_slider');
    posts_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'slide',
            rewind: true,
            pagination: false,
            perPage: 3,
            perMove: 1,
        drag: 'free',
            gap: '2.5rem',
            breakpoints: {
                768: {
                    perPage: 1,
                    gap: '1.5rem',
                },
                1200: {
                    perPage: 2,
                    gap: '1.5rem',
                },
                1400: {
                    perPage: 3,
                    gap: '1.5rem',
                },
            }
        }).mount();
    });

    const team_members_slider = document.querySelectorAll('.team_members_slider');
    team_members_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'slide',
            rewind: true,
            pagination: false,
            perPage: 3,
            perMove: 1,
            drag: 'free',
            gap: '2.5rem',
            breakpoints: {
                768: {
                    perPage: 1,
                    gap: '1.5rem',
                },
                1200: {
                    perPage: 2,
                    gap: '1.5rem',
                },
                1400: {
                    perPage: 3,
                    gap: '1.5rem',
                },
            }
        }).mount();
    });

    const testimonials_slider = document.querySelectorAll('.testimonials_slider');
    testimonials_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'slide',
            rewind: true,
            perPage: 1,
            perMove: 1,
            gap: '2.5rem',
        }).mount();
    });

    const hero_gallery_slider = document.querySelectorAll('.hero_gallery_slider');
    hero_gallery_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'fade',
            rewind: true,
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 4000,
            speed: 1500,
        }).mount();
    });

    const content_image_slider_single = document.querySelectorAll('.content_image_slider_single');
    content_image_slider_single.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'fade',
            rewind: true,
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 4000,
            speed: 1500,
        }).mount();
    });

    const content_image_slider_left = document.querySelectorAll('.content_image_slider_left');
    content_image_slider_left.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'loop',
            rewind: true,
            direction: 'ttb',
            perPage: 4,
            perMove: 1,
            arrows: false,
            pagination: false,
            height: '100%',
            drag: false,
            autoScroll: {
              speed: 0.25,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
        }).mount(window.splide.Extensions);
    });

    const content_image_slider_right = document.querySelectorAll('.content_image_slider_right');
    content_image_slider_right.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'loop',
            rewind: true,
            direction: 'ttb',
            perPage: 4,
            perMove: 1,
            arrows: false,
            pagination: false,
            height: '100%',
            drag: false,
            autoScroll: {
              speed: -0.25,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
        }).mount(window.splide.Extensions);
    });

    const posts_category_slider = document.querySelectorAll('.posts_category_slider');
    posts_category_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'slide',
            rewind: true,
            pagination: false,
            autoWidth: true,
            arrows: false,
            gap: '0.5rem',
            drag: 'free',
            snap: false,
        }).mount();
    });

    const footer_locations_slider = document.querySelectorAll('#footer_locations_slider');
    footer_locations_slider.forEach((slider, index) => { 
        new Splide(slider, {
           type: 'slide',
           rewind: true,
           pagination: false,
           autoWidth: true,
           arrows: false,
           drag: 'free',
           snap: false,
        }).mount();
    });
});

document.addEventListener( 'DOMContentLoaded', function () {
    const footer_locations_slider = document.querySelectorAll('#footer_locations_slider');

    footer_locations_slider.forEach((slider, index) => { 
        new Splide(slider, {
            type: 'slide',
            rewind: true,
            pagination: false,
            autoWidth: true,
            arrows: false,
            drag: 'free',
            snap: false,
      }).mount();
    });
});

(function($) {

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    
    window.initGoogleMaps = function () {
      document.querySelectorAll('.acf-map').forEach(el => {
        initMap(el);
      });
    };

    function initMap(el) {
      const markers = el.querySelectorAll('.marker');

      const map = new google.maps.Map(el, {
        zoom: 13,
        disableDefaultUI: true,
        gestureHandling: "none",
        zoomControl: false,
        mapId: el.getAttribute('id'),
      });

      map.markers = [];

      markers.forEach(markerEl => {
        initMarker(markerEl, map);
      });

      centerMap(map);
    }

    function initMarker(markerEl, map) {
      const lat = parseFloat(markerEl.dataset.lat);
      const lng = parseFloat(markerEl.dataset.lng);
      const position = new google.maps.LatLng(lat, lng);

      // Create a custom SVG element inside a div (AdvancedMarkerElement uses DOM elements)
      const iconContainer = document.createElement('div');
      iconContainer.innerHTML = `
        <svg width="30" height="39.9" viewBox="0 0 54 72" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1109_8)">
            <path d="M54 27C54 39.2906 37.5469 61.1719 30.3328 70.2C28.6031 72.3516 25.3969 72.3516 23.6672 70.2C16.4531 61.1719 0 39.2906 0 27C0 12.0938 12.0938 0 27 0C41.9062 0 54 12.0938 54 27Z" fill="#134882"/>
          </g>
          <defs>
            <clipPath id="clip0_1109_8">
              <rect width="54" height="72" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      `;
      // iconContainer.style.transform = "translate(-27px, -72px)"; // offset to anchor tip

      const marker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position,
        content: iconContainer,
      });

      map.markers.push(marker);

      if (markerEl.innerHTML.trim()) {
        const infoWindow = new google.maps.InfoWindow({
          content: markerEl.innerHTML
        });

        marker.addListener('gmp-click', () => {
          infoWindow.open(map, marker);
        });
      }
    }

    function centerMap(map) {
      const bounds = new google.maps.LatLngBounds();
      map.markers.forEach(marker => {
        bounds.extend(marker.position);
      });

      if (map.markers.length === 1) {
        map.setCenter(bounds.getCenter());
      } else {
        map.fitBounds(bounds);
      }
    }

// Inject current page URL into all CF7 forms as a hidden field
// so popup submissions include the page they were triggered from.
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wpcf7-form').forEach(function (form) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'source-page';
        input.value = window.location.href;
        form.appendChild(input);
    });
});

// Prevent duplicate submissions (e.g. double-clicking submit) on all CF7 forms,
// including the sitePopupTrigger popup form.
(function () {
    var RESUBMIT_DELAY = 5000; // ms before the submit button is re-enabled
    var timers = new WeakMap();

    function getSubmitButton(form) {
        return form.querySelector('input[type="submit"], button[type="submit"]');
    }

    function lockButton(form) {
        var button = getSubmitButton(form);
        if (!button || button.disabled) return;

        button.disabled = true;
        button.classList.add('is-submitting');

        // Safety net in case a CF7 completion event never fires.
        var timer = setTimeout(function () {
            unlockButton(form);
        }, RESUBMIT_DELAY);
        timers.set(form, timer);
    }

    function unlockButton(form) {
        var button = getSubmitButton(form);
        var timer = timers.get(form);
        if (timer) {
            clearTimeout(timer);
            timers.delete(form);
        }
        if (button) {
            button.disabled = false;
            button.classList.remove('is-submitting');
        }
    }

    document.addEventListener('submit', function (event) {
        if (event.target.classList && event.target.classList.contains('wpcf7-form')) {
            lockButton(event.target);
        }
    }, true);

    // CF7 dispatches this on the form after every Ajax submission outcome
    // (mail sent, mail failed, validation failed, spam, aborted).
    document.addEventListener('wpcf7submit', function (event) {
        unlockButton(event.target);
    }, false);
})();

})(jQuery);

document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.content-map-section .accordion-body p').forEach(function (p) {

        const text = p.textContent.trim();
        const postcodes = text.split('|');

        p.innerHTML = '';

        postcodes.forEach(function (postcode, index) {

            postcode = postcode.trim();

            if (!postcode) return;

            const span = document.createElement('span');
            span.textContent = postcode + (index < postcodes.length - 1 ? ' |' : '');

            p.appendChild(span);

            // Add a normal space between postcode groups
            if (index < postcodes.length - 1) {
                p.appendChild(document.createTextNode(' '));
            }
        });
    });

});

// Territory availability checker (page builder block)
document.addEventListener('DOMContentLoaded', function () {

    // UK postcodes always end in a 3-character inward code, whose first digit is the sector number.
    function getPostcodeSector(postcode) {
        var compact = postcode.replace(/\s+/g, '').toUpperCase();
        if (compact.length <= 3) return compact;
        var outward = compact.slice(0, -3);
        var sectorDigit = compact.slice(-3, -2);
        return outward + ' ' + sectorDigit;
    }

    // Rejects district-only input (e.g. "WA12") that's missing the inward code, which would
    // otherwise be mis-parsed into a bogus sector.
    var FULL_POSTCODE_PATTERN = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i;
    function isFullPostcode(postcode) {
        return FULL_POSTCODE_PATTERN.test(postcode.trim());
    }

    // Reuses the same Geocoding REST API as geocodePostcode(), just in reverse — no Maps JS needed.
    async function reverseGeocodeToPostcode(lat, lng) {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${CONFIG.apiKey}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.status === 'OK') {
            for (const result of data.results) {
                const postcodeComponent = (result.address_components || []).find(function (component) {
                    return component.types.indexOf('postal_code') !== -1;
                });
                if (postcodeComponent) return postcodeComponent.long_name;
            }
        }

        throw new Error('Could not determine a postcode for this location');
    }

    function initTerritoryChecker(section) {
        var dataEl = section.querySelector('.territory-checker-data');
        var form = section.querySelector('.territory-checker-form');
        var resultEl = section.querySelector('.territory-checker-result');

        if (!dataEl || !form || !resultEl) return;

        var data;
        try {
            data = JSON.parse(dataEl.textContent);
        } catch (error) {
            console.error('Territory checker: invalid data', error);
            return;
        }

        var territories = data.territories || {};
        var sectorIndex = data.sectorIndex || {};

        var idlePanel = resultEl.querySelector('.result-panel-idle');
        var availablePanel = resultEl.querySelector('.result-panel-available');
        var unavailablePanel = resultEl.querySelector('.result-panel-unavailable');
        var postcodeEl = availablePanel ? availablePanel.querySelector('.result-postcode') : null;

        function showPanel(panel) {
            [idlePanel, availablePanel, unavailablePanel].forEach(function (p) {
                if (p) p.hidden = (p !== panel);
            });
        }

        function showIdleMessage(message) {
            if (idlePanel) {
                var p = idlePanel.querySelector('.result-message');
                if (p) p.textContent = message;
            }
            showPanel(idlePanel);
        }

        function showAvailable(postcode) {
            if (postcodeEl) postcodeEl.textContent = postcode;
            showPanel(availablePanel);
        }

        function showUnavailable() {
            showPanel(unavailablePanel);
        }

        var locationButton = section.querySelector('.territory-use-location');
        var postcodeInput = form.querySelector('.territory-postcode-input');
        var locationLabel = locationButton ? locationButton.querySelector('.location-label') : null;

        if (locationButton && postcodeInput && locationLabel && navigator.geolocation) {
            locationButton.addEventListener('click', function () {
                var originalText = locationLabel.textContent;
                locationButton.disabled = true;
                locationLabel.textContent = 'Finding your location\u2026';

                navigator.geolocation.getCurrentPosition(async function (position) {
                    try {
                        var postcode = await reverseGeocodeToPostcode(
                            position.coords.latitude,
                            position.coords.longitude
                        );
                        postcodeInput.value = postcode;
                        form.requestSubmit();
                    } catch (error) {
                        console.error('Territory checker: reverse geocode failed', error);
                        showIdleMessage('Could not determine a postcode for your location. Please enter it manually.');
                    } finally {
                        locationButton.disabled = false;
                        locationLabel.textContent = originalText;
                    }
                }, function () {
                    // Permission denied, timeout, or position unavailable.
                    showIdleMessage('Could not access your location. Please enter your postcode manually.');
                    locationButton.disabled = false;
                    locationLabel.textContent = originalText;
                });
            });
        } else if (locationButton) {
            // No geolocation support in this browser — don't offer a button that can't work.
            locationButton.remove();
        }

        form.addEventListener('submit', function (event) {
            event.preventDefault();

            var input = form.querySelector('.territory-postcode-input');
            var postcode = input ? input.value.trim() : '';

            if (!postcode) return;

            if (!isFullPostcode(postcode)) {
                showIdleMessage('Please enter a full UK postcode, e.g. WA12 1AB.');
                return;
            }

            var sector = getPostcodeSector(postcode);
            var territoryName = sectorIndex[sector];
            var territory = territoryName ? territories[territoryName] : null;

            // Anywhere not explicitly listed as taken/coming soon is assumed open for franchising.
            if (!territory || territory.status === 'available') {
                showAvailable(postcode);
                return;
            }

            showUnavailable();
        });
    }

    document.querySelectorAll('.territory-checker-section').forEach(initTerritoryChecker);
});